import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "../src/assets/styles/index.scss";
import App from "./App";
import { store } from "./app/core/store";
import { initI18n } from "./i18n";
import reportWebVitals from "./reportWebVitals";

initI18n();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SnackbarProvider
        style={{ fontSize: "1.4rem", fontWeight: 700 }}
        maxSnack={3}
        autoHideDuration={3000}
        hideIconVariant
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <App />
      </SnackbarProvider>
    </Provider>
  </React.StrictMode>
  // document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
